import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import {
  getMemberOfflineService,
  MemberActiveOfflineService,
} from "../../../ApiServices/Apifun";
import { Popconfirm, Spin } from "antd";
import { dispatchtoast } from "../../../Utils";

const OfflineShare = () => {
  const dispatch = useDispatch();
  const [serviceList, setServiceList] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const getServiceList = () => {
    setPageLoader(true);
    getMemberOfflineService()
      .then((res) => {
        if (res.status) {
          setServiceList(res.offline_services);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setPageLoader(false));
  };
  const handleActiveService = (id) => {
    setPageLoader(true);
    const formdata = new FormData();
    formdata.append("service_id", id);
    MemberActiveOfflineService(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
          getServiceList();
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    dispatch(setselectedTab("5001"));
    getServiceList();
  }, []);
  return (
    <>
      <div className="bg-white rounded-lg p-4">
        <p className="font-bold">Service List</p>
        <Spin spinning={pageLoader}>
          {serviceList.length > 0 ? (
            serviceList.map((i, index) => {
              return (
                <div
                  key={index}
                  className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 place-items-start xl:place-items-center bg-primary p-4 mt-4 rounded-md font-semibold text-white text-sm md:text-sm gap-2"
                >
                  <img
                    src={i.image}
                    alt="service imgae"
                    className="w-28 h-28 rounded-lg object-cover"
                  />
                  <p className="flex justify-start items-center  w-full">
                    {i?.service_name}
                  </p>
                  <button
                    className={` ${
                      !i.status && i.active
                        ? "cursor-not-allowed opacity-75 bg-gray-500"
                        : "cursor-pointer bg-green-600"
                    } px-4 py-2 text-white`}
                  >
                    {/* {!i.status && i.active ? (
                      "Go to link"
                    ) : i.status && i.active ? (
                      <p onClick={() => window.open(i.service_link, "_blank")}>
                        Go to link
                      </p>
                    ) : (
                      "Go to link"
                    )} */}
                    {i.status && i.active ? (
                      <p onClick={() => window.open(i.service_link, "_blank")}>
                        Go to link
                      </p>
                    ) : (
                      "Go to link"
                    )}
                  </button>
                  <p className=" w-full">
                    Amount to be debited
                    <span className="text-white text-lg"> ₹ {i?.amount}</span>
                  </p>
                  <Popconfirm
                    placement="leftBottom"
                    okButtonProps={{
                      className: "bg-primary text-white border-none",
                      onClick: () => handleActiveService(i.id),
                    }}
                    title={
                      <p className="font-semibold mb-4">
                        Are you sure you want to activate?
                      </p>
                    }
                  >
                    <button
                      disabled={i.status || i.active}
                      className={` ${
                        i.status || i.active
                          ? "cursor-not-allowed opacity-75 bg-gray-500"
                          : "cursor-pointer bg-orange-600"
                      } px-4 py-2 text-white`}
                    >
                      Active
                    </button>
                  </Popconfirm>
                </div>
              );
            })
          ) : (
            <div className="flex justify-center items-center mt-4 font-bold">
              <p>No service list found</p>
            </div>
          )}
        </Spin>
      </div>
    </>
  );
};

export default OfflineShare;
